import {RootState} from '../rootReducer';

export const modelAccessSelector = (state: RootState) => state.modelAccess;
